export const ITEMS_DISABLE_COMPANY_INACTIVE = ['Beneficiários'];
export const ITEMS_TOOLTIP = [
  {
    item: 'Beneficiários',
    show: true,
    message:
      'Esta empresa não possui contratos ativos com a Vitta. Portanto, não é possível realizar movimentações de beneficiários.',
  },
];
